import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Week from "../Components/Week";
import Banner from "../Components/Banner";

const Second_Blog = () => {
  const styles = {
    h4: {
      color: "#006a4f",
      fontFamily: `'Poppins', sans-serif`,
    },
    h6: {
      color: "#006a4f",
      fontFamily: `sans-serif`,
      fontSize: "1.2rem",
      fontWeight: 500,
    },
    span: {
      color: "#c63b36",
      fontSize: "1.1rem",
      fontWeight: 700,
    },
    p: {
      fontFamily: `serif`,
      //   color: '#878787',
      fontSize: "1.25rem",
      color: "#001f3f",
      wordSpacing: "0.3rem",
    },
    //    main_heading:{
    //     fontSize:"2rem",
    //     textAlign:"center"
    //    }
  };
  //    className="col-md-6 order-md-2"

  const ImageComponent = () => {
    const styles = {
      container: {
        width: "100%",
        overflow: "hidden",
        borderRadius: "10px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      },
      image: {
        width: "100%",
        display: "block",
      },
    };

    return (
      <div style={styles.container} className="mb-3">
        <img src="https://cdn.pixabay.com/photo/2019/04/15/12/09/machine-learning-4129175_1280.jpg" alt="Example" style={styles.image} />
      </div>
    );
  };

  return (
    <>
      <style>
        @import
        url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
        {`
          @media (max-width: 600px) {
            h4 {
              font-size: 1.3rem;
              text-align: center;
            }
            h6 {
             font-size: 1rem;
            }
            span {
              font-size: 1rem;
            }
            p{
              font-size: 1rem;
              padding: 0 1rem;
              text-align: justify;
            }
            a{
            text-decoration:none;
            }
          }
        `}
      </style>
      <div className="container">
        <Banner heading={"Breaking Into AI & Machine Learning: A Beginner’s Guide"}
        image={"https://cdn.pixabay.com/photo/2024/02/26/09/17/synthetic-8597464_640.jpg"}
        />
        <section className="container mt-5">
          {/* First Section: Text Left, Image Right */}
          <div className="row align-items-center mb-5">
            <div className="col">
              <p className="" style={styles.p}>
                Artificial Intelligence (AI) and Machine Learning (ML) are
                transforming industries worldwide, and the demand for skilled AI
                professionals is skyrocketing. If you are based in Jalandhar,
                Punjab, and looking to step into this exciting field, CoderMonk
                is here to guide you. In this blog, we will outline a
                beginner-friendly roadmap to help you start your journey in AI
                and ML.
              </p>
            </div>
          </div>

          {/* Second Section: Image Left, Text Right */}
          <div className="row align-items-center mb-3">
            <div className="col">
              <h4 style={styles.h4}>
                Why AI & Machine Learning Matter in 2024
              </h4>
              <p className="" style={styles.p}>
                From automating business operations to enhancing medical
                diagnostics, AI is reshaping the future. Big tech companies like
                Google, Microsoft, and Tesla are investing heavily in AI-driven
                solutions. The good news? You don’t need a PhD to break into
                this field. With the right resources, mentorship, and structured
                learning, anyone can master AI and ML.
              </p>
            </div>
          </div>
          <ImageComponent />
          <img src="" />
          {/* Third Section: Text Left, Image Right */}
          <div className="row align-items-center mb-2">
            <div className="col">
              <h4 style={styles.h4}>
                Getting Started: The Roadmap for Beginners
              </h4>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col">
              <ol style={{ listStyleType: "decimal" }}>
              {[
  {
    title: "Learn the Fundamentals of Programming",
    description: [
      <>● The best languages for AI and ML are <span style={styles.span}>Python</span> and <span style={styles.span}>R</span>.</>,
      <>● Start with basic concepts like variables, loops, and functions.</>,
      <>● Platforms like <span style={styles.span}>Codecademy,Coursera</span>, and <span style={styles.span}>CoderMonk</span> offer beginner-friendly Python courses.</>
    ]
  },


                  {
                    title: ". Mathematical Foundations",
                    description: [
                      "● Linear Algebra, Probability, and Statistics are crucial for understanding ML algorithms.",
                      <>●  Learn concepts like <span style={styles.span}>matrices, vectors,</span> and <span style={styles.span}> probability distributions</span> .</>,
                      "● Khan Academy and MIT OpenCourseWare are excellent resources.",
                    ],
                  },
                  {
                    title: "Understand Machine Learning Concepts",
                    description: [
                      <>● Learn about <span style={styles.span}></span>Supervised vs. <span style={styles.span}></span>Unsupervised Learning.</>,
                      <>● Study algorithms like <span style={styles.span}></span>Decision Trees, Random Forests, and <span style={styles.span}></span>Neural Networks.</>,
                      <>● Get hands-on experience with libraries like <span style={styles.span}></span>Scikit-learn, TensorFlow, and <span style={styles.span}></span>PyTorch.</>
                    ],
                  },

                  {
                    title: "Work on Real-World Projects",
                    description: [
                      <>● Theory alone won’t make you an AI expert. Start building projects!</>,
                      <>● Work on projects like  <span style={styles.span}></span>chatbots, recommendation systems, and  <span style={styles.span}></span>AI-powered automation tools</>,
                      <>●  <span style={styles.span}></span>Join the CoderMonk AI Bootcamp in Jalandhar to work on real-world applications.</>,
                    ],
                  },
                  {
                    title: "Dive into Deep Learning & Neural Networks",
                    description: [
                      <>● Learn about Convolutional  <span style={styles.span}>Neural Networks (CNNs)</span>  and  <span style={styles.span}>Recurrent Neural Networks (RNNs).</span></>,
                      <>● Experiment with  <span style={styles.span}>OpenAI’s GPT models</span> and  <span style={styles.span}>Whisper AI.</span></>,
                      <>● Participate in  <span style={styles.span}>hackathons</span> and  <span style={styles.span}>Kaggle competitions.</span></>
                    ],
                  },
                  {
                    title: "Understand AI Ethics and Deployment",
                    description: [
                      <>● AI must be used responsibly. Learn about  <span style={styles.span}>bias in AI models</span> and  <span style={styles.span}>ethical AI development.</span></>,
                      <>● Understand deployment techniques using  <span style={styles.span}>Flask, FastAPI,</span> and cloud platforms like  <span style={styles.span}>AWS, GCP,</span> and  <span style={styles.span}>Azure.</span></>
                    ],
                  },
                ].map((item, index) => (
                  <li className="list-group-item" key={index}>
                    <h6 style={styles.h6}>
                      {index + 1}. {item.title}
                    </h6>
                    <ul>
                      {item.description.map((subItem, subIndex) => (
                        <li key={subIndex} style={styles.p} className="mb-2">
                          {subItem}
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ol>
            </div>
          </div>
          <div className="row align-items-center mb-2">
            <div className="col">
              <h4 style={styles.h4}>Why Learn AI at CoderMonk in Jalandhar?</h4>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col">  
            <div className="d-flex flex-column ms-3">
  <div className="col-12 mb-1">
    <span style={styles.h6}>● Hands-on AI Training:</span>
    <span style={styles.p}> Unlike other institutes, we focus on  <span style={styles.span}>practical learning.</span></span>
  </div>
  <div className="col-12  mb-1">
    <span style={styles.h6}>● Industry-Relevant Curriculum:</span>
    <span style={styles.p}>: We integrate  <span style={styles.span}>ChatGPT, Whisper AI,</span> and  <span style={styles.span}>Web 3.0 </span>into our courses.</span>
  </div>
  <div className="col-12  mb-1">
    <span style={styles.h6}>● Job-Oriented Approach: </span>
    <span style={styles.p}> We help students build portfolios that make them job-ready.</span>
  </div>

  <div className="col-12  mb-1">
    <span style={styles.h6}>●  Expert Mentors: </span>
    <span style={styles.p}> Learn from experienced AI professionals.</span>
  </div>
  <div className="col-12">
    <span style={styles.h6}>●  Networking Opportunities:</span>
    <span style={styles.p}> Connect with like-minded tech enthusiasts in  <span style={styles.span}>Jalandhar,Punjab.</span></span>
  </div>
</div>

                    
           
            </div>
          </div>

          <div className="row align-items-center mb-5">
            <div className="col">
              <h4 style={styles.h4}>Take the First Step Today!</h4>
              <p className="" style={styles.p}>
                Breaking into AI is not as difficult as it seems. With
                structured learning, practical exposure, and expert mentorship,
                you can build a successful career in AI and ML. Whether you're a
                college student, a working professional, or someone switching
                careers, <span style={styles.span}>CoderMonk is the best place in Jalandhar to learn AI &
                Machine Learning.</span> 
              </p>

              <hr />
              <p className="" style={styles.p}>
                Are you ready to embark on your AI journey? Join CoderMonk
                today!
              </p>
              <div className="d-flex flex-column">
                <a
                  href="/testing"
                  style={{ ...styles.p, textDecoration: "none" }}
                  className="mb-2"
                >
                  📍 Location: Jalandhar, Punjab
                </a>
                <a
                  href="tel:6284636956"
                  style={{ ...styles.p, textDecoration: "none" }}
                    className="mb-2"
                >
                  📞 Contact: +916284636956
                </a>

                <a
                  href="mailto:info@codermonk.in"
                  style={{ ...styles.p, textDecoration: "none" }}
                >
                  🌐 Website: info@codermonk.in
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Second_Blog;
